import { atom } from "jotai";

/**
 * Defines the structure for the state controlling the custom WarningAlert component.
 */
export interface WarningAlertState {
  isOpen: boolean;
  title: string;
  message?: string;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  status?: "warning" | "error" | "info";
  onPrimaryAction: () => void | Promise<void>;
  onSecondaryAction?: () => void;
  isPrimaryLoading?: boolean;
}

const defaultWarningAlertState: WarningAlertState = {
  isOpen: false,
  title: "",
  message: "",
  primaryButtonText: "Confirm",
  secondaryButtonText: "Cancel",
  status: "warning",
  onPrimaryAction: () => {},
  onSecondaryAction: undefined,
  isPrimaryLoading: false,
};

/**
 * Atom controlling the state and props of the custom WarningAlert component.
 * Use functions within useUnsavedChangesWarning hook to manipulate this state.
 */
export const warningAlertStateAtom = atom<WarningAlertState>(
  defaultWarningAlertState,
);
warningAlertStateAtom.debugLabel = "warningAlertStateAtom";
